import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const makePaymentPromise = import("./MakePayment.js");
export default Auth(lazy(() => makePaymentPromise));
